import * as _ from 'lodash';
import { environment } from '../environments/environment';

const appSettings = {
    showTaskTab: _.get(environment, 'TASK_TAB', 'false').toLowerCase() === 'true',
    showSyncSolrAUDataCheckbox: _.get(environment, 'SHOW_SYNC_SOLR_AU_DATA_CHECKBOX', 'false').toLowerCase() === 'true',
    allowSyncSolrAUData: _.get(environment, 'ALLOW_SYNC_SOLR_AU_DATA', 'true').toLowerCase() === 'true',
    skipSolrAUDataSyncForForcedMode:
        _.get(environment, 'SKIP_SOLR_AU_DATA_SYNC_FOR_FORCED_MODE', 'false').toLowerCase() === 'true'
};

export { appSettings };
